export const environment = {
    production: true,
    stage: 'test',
    backendUrl: process.env.REACT_APP_BACKEND_URL ?? 'https://test.backend.modernmedicus.pl/api',
};
